import React from 'react';
import { RefreshCw } from 'lucide-react';

export default function RefreshButton({ onClick, isLoading, lastUpdated, className = '' }) {
  const formatTime = (date) => {
    if (!date) return '';
    const now = new Date();
    const diff = Math.floor((now - new Date(date)) / 1000);

    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return new Date(date).toLocaleDateString();
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {lastUpdated && (
        <span className="text-xs text-text-muted">
          Updated {formatTime(lastUpdated)}
        </span>
      )}
      <button
        onClick={onClick}
        disabled={isLoading}
        className="p-1.5 rounded-lg hover:bg-bg-secondary text-text-muted hover:text-text-primary transition-colors disabled:opacity-50"
        title="Refresh"
      >
        <RefreshCw className={`w-4 h-4 ${isLoading ? 'animate-spin' : ''}`} />
      </button>
    </div>
  );
}
